module.exports = __webpack_public_path__ + "img/steam.b0118201.png";